import { Col, Row } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';

import type { EditModel } from 'edit/EditModel';
import { EditDialog } from 'edit/EditDialog';
import { EditFolderReference } from 'edit/reference/EditFolderReference';
import { EditZoneReference } from 'edit/reference/EditZoneReference';
import { EditString } from 'components/forms/EditString';
import { EditText } from 'components/forms/EditText';
import { EditNumber } from 'components/forms/EditNumber';
import type { Lock } from 'api/locks/endpoints/getLock';

import type { EditableLock } from './EditableLock';

interface Props {
  readonly model: EditModel<EditableLock, Lock | null>;
  readonly onSaved: () => void;
  readonly onClose: () => void;
}

export const EditLockDialog = ({ model, onSaved, onClose }: Props) => (
  <EditDialog model={model} onSaved={onSaved} onClose={onClose} entityName="Lock">
    {(entity) => <FormFields entity={entity} />}
  </EditDialog>
);

interface FieldsProps {
  readonly entity: EditableLock;
}

const FormFields = observer<FieldsProps>(({ entity }) => (
  <>
    <Row>
      <Col md={12}>
        <EditString label="Name" value={entity.name} onChange={(v) => (entity.name = v)} mandatory />
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <EditZoneReference
          value={entity.zone}
          onChange={(zone) => {
            // Folder is zone-scoped — clear it when the zone changes.
            entity.zone = zone;
            entity.folder = null;
          }}
          resourceType="locks"
          action={entity.isCreating ? 'create' : 'update'}
          mandatory
        />
      </Col>
      <Col md={6}>
        <EditFolderReference value={entity.folder} onChange={(v) => (entity.folder = v)} zoneName={entity.zone?.name} />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <EditText label="Description" value={entity.description} onChange={(v) => (entity.description = v)} />
      </Col>
    </Row>

    <Row>
      <Col md={4}>
        <EditNumber label="Limit" value={entity.limit} onChange={(v) => (entity.limit = v)} min={1} mandatory />
      </Col>
    </Row>
  </>
));
